import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientPatientPrescriptions } from '../models/clinical-history.model';

// Read/download only: prescriptions are issued exclusively in ProVet Cloud now, so this repository
// only ever backs the client-detail "Recetas" tab. `downloadPdf` generates the PDF fresh on every
// call, independent of `documentId`.
export interface IClientPrescriptionsRepository {
  getForClient(clientId: string): Observable<readonly ClientPatientPrescriptions[]>;
  downloadPdf(clientId: string, patientId: string, prescriptionExternalId: string, locale: string): Observable<Blob>;
}

export const CLIENT_PRESCRIPTIONS_REPOSITORY =
  new InjectionToken<IClientPrescriptionsRepository>('IClientPrescriptionsRepository');
